<div class="loadable" [class.loading]="knowYourService.isLoading">
    <div>
        <span>{{ 'payroll.kyc-kyb.pre-redirect.' + scope() + '.instructions' | translate }}</span
        >&nbsp;<span
            innerHTML="{{
                'payroll.kyc-kyb.forMoreInfo.message'
                    | translate: { helpCenterUrl: 'payroll.kyc-kyb.forMoreInfo.helpCenterUrl' | translate }
            }}"
        ></span>
    </div>
    <h3 level="2">{{ 'payroll.kyc-kyb.pre-redirect.whyDoThis' | translate }}</h3>
    <div>{{ 'payroll.kyc-kyb.pre-redirect.' + scope() + '.whyDoThis' | translate }}</div>
    <h3 level="2">{{ 'payroll.kyc-kyb.pre-redirect.whatYouNeed' | translate }}</h3>
    <div>{{ 'payroll.kyc-kyb.pre-redirect.' + scope() + '.whatYouNeed.description' | translate }}</div>
    @for (
        whatYouNeed of 'payroll.kyc-kyb.pre-redirect.' + scope() + '.whatYouNeed.items' | translate;
        track whatYouNeed
    ) {
        @if (whatYouNeed.title) {
            <h4 level="3">{{ whatYouNeed.title }}</h4>
        }
        @if (whatYouNeed.description) {
            <div>{{ whatYouNeed.description }}</div>
        }
        @if (whatYouNeed.children) {
            <ul>
                @for (whatYouNeedChild of whatYouNeed.children; track whatYouNeedChild) {
                    <li>{{ whatYouNeedChild }}</li>
                }
            </ul>
        }
    }
    <div>{{ 'payroll.kyc-kyb.pre-redirect.' + scope() + '.footer' | translate }}</div>
    <ui-button type="primary" (click)="launchPersona()">{{
        'payroll.kyc-kyb.pre-redirect.' + scope() + '.button' | translate
    }}</ui-button>
</div>

<ui-dialog
    size="small"
    header="payroll.kyc-kyb.pre-redirect.KYB.signing-officer-dialog.title"
    [stickyButtons]="true"
    [stickyHeader]="true"
    [open]="isKYBSigningOfficerFormOpen"
    (closing)="closeDialog()"
>
    <app-kyb-signing-officer-form #kybSigningOfficerForm />
    <ui-dialog-footer class="sticky-buttons">
        <ui-button (click)="closeDialog()">{{ 'cancel' | translate }}</ui-button>
        <ui-button
            (click)="submitSigningOfficerForm(kybSigningOfficerForm)"
            [disabled]="!kybSigningOfficerForm.isFormValid()"
            type="primary"
            >{{ 'continue' | translate }}</ui-button
        >
    </ui-dialog-footer>
</ui-dialog>
